/**
 * Brand registry — build-time house-brand selection for the admin portal.
 *
 * This module is **environment-agnostic** (no `import.meta.env`) so it can be
 * imported by both `vite.config.ts` (Node) and the browser app. The brand
 * baked into THIS build is exposed separately by `brands/active.ts` (client
 * only), which reads the `VITE_BRAND` value injected by `vite.config.ts`.
 *
 * See `BRANDING.md` for how to add a brand.
 */
import type { BrandConfig } from './types';
import nuur from './nuur/brand';
import mazeed from './mazeed/brand';

export type { BrandConfig } from './types';

export const BRANDS: Record<string, BrandConfig> = { nuur, mazeed };

/** Baked-in default when no brand is selected — preserves legacy behaviour. */
export const DEFAULT_BRAND_KEY = 'nuur';

/** Resolve a brand key to its config, falling back to the default brand. */
export function resolveBrand(key?: string | null): BrandConfig {
  return BRANDS[(key ?? '').toLowerCase()] ?? BRANDS[DEFAULT_BRAND_KEY];
}
